// istanbul ignore file — composition shell; logic lives in hooks, slices, and child modules.

import { I18n } from '@calendly/i18n'
import { IconButton } from '@calendly/ui/components/icon-button'
import { CloseIcon } from '@calendly/ui/components/icons'
import { PageHeader } from '@calendly/ui/components/page-header'
import { lazy, Suspense } from 'react'

import { Switcher } from './switcher'

const StandaloneUsersPeoplePageHeader = lazy(() => (
  import('./users_people_page_header_standalone').then((m) => ({
    default: m.StandaloneUsersPeoplePageHeader,
  }))
))

/**
 * CUI PageHeader shared by the standalone Users area and the settings modal people sections.
 * Tabs use `Switcher` (`switcher.js`: CUI Tabs + routing) in both layouts.
 *
 * @param {{ variant: 'standalone' }} props
 * @param {{ variant: 'embedded', title: string, onClose: () => void, showCloseInHeader?: boolean }} props — settings modal main pane
 */
export function UsersPeoplePageHeader({ variant, title, onClose, showCloseInHeader = true }) {
  if (variant === 'embedded') {
    return (
      <PageHeader
        wide
        title={title}
        tabs={<Switcher />}
        actions={showCloseInHeader ? [
          <IconButton
            key="settings-modal-close"
            type="button"
            title={I18n.t('publisher.action.close')}
            aria-label={I18n.t('publisher.action.close')}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>,
        ] : []}
      />
    )
  }

  return (
    <Suspense fallback={null}>
      <StandaloneUsersPeoplePageHeader />
    </Suspense>
  )
}
